import { render, staticRenderFns } from "./LookupCustomerCode.vue?vue&type=template&id=0fab7b85&scoped=true"
import script from "./LookupCustomerCode.vue?vue&type=script&lang=ts"
export * from "./LookupCustomerCode.vue?vue&type=script&lang=ts"
import style0 from "./LookupCustomerCode.vue?vue&type=style&index=0&id=0fab7b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab7b85",
  null
  
)

export default component.exports